import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import initI18n from "./scripts/i18n";

// 初始化多语言
initI18n();

initScrollReveal(targetElements, defaultProps);
initTiltEffect();
